import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../searchtopbox/SearchTopBox.css'
import FilterSearch from '../filtersearch/FilterSearch'
import Radius from '../radius/Radius'
import SearchService from '../searchService/SearchService'
import SearchWorker from '../searchWorker/SearchWorker'

const SearchTopBox = () => {
    const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
  return (
    <>
    <div className=''>
        <div className='searchbox-header-top  d-flex flex-wrap align-content-center'>
              <div className='search-box'>
                <div className="search-container">
                  <form action="">
                    <div className='form-search-box'>
                      <button type="submit">
                        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3418 19.25C16.1512 19.25 20.0501 15.3512 20.0501 10.5417C20.0501 5.7322 16.1512 1.83334 11.3418 1.83334C6.53228 1.83334 2.63342 5.7322 2.63342 10.5417C2.63342 15.3512 6.53228 19.25 11.3418 19.25Z" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.9668 20.1667L19.1334 18.3333" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </button>
                      <input type="search" placeholder="Search.." name="" />
                    </div>
                  </form>
                </div>
              </div>
              <div className='right-filter-sec new-filter-sec d-flex flex-xl-nowrap flex-wrap align-items-center gap-2'>
                <ul className='tabs-header'>
                  <li className="dropdown">
                    <Link rel='stylesheet' className='dropdown-toggle btn btn-border d-flex align-items-center gap-2'  data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-label="Toggle filter options">
                      <span className='icon-box'>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9231 7.92308C17.9231 12.5385 11 17.9231 11 17.9231C11 17.9231 4.0769 12.5385 4.0769 7.92308C4.0769 4.15231 7.22921 1 11 1C14.7708 1 17.9231 4.15231 17.9231 7.92308Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.0001 10.2308C12.2746 10.2308 13.3078 9.19759 13.3078 7.92308C13.3078 6.64857 12.2746 5.61539 11.0001 5.61539C9.72557 5.61539 8.69238 6.64857 8.69238 7.92308C8.69238 9.19759 9.72557 10.2308 11.0001 10.2308Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.2728 15.6154H18.6923L21 21H1L3.30769 15.6154H4.72723" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </span>
                      <span className='text-box'>Radius 1.5km</span>
                    </Link>
                    <div class="dropdown-menu filter-radius">
                      <Radius />
                    </div>
                  </li>
                </ul>
                <ul className='tabs-header ms-4 d-flex flex-xl-nowrap flex-wrap align-items-center justify-content-between gap-2'>
                  <li className="dropdown pe-2">
                    <Link rel='stylesheet' className='dropdown-toggle d-flex align-items-center ' data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-label="Toggle filter options">
                      <span className='icon-box'>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.9998 1H0.999756L8.69206 11.7692V21L13.3074 17.9231V11.7692L20.9998 1Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </span>
                    </Link>
                    <div class="dropdown-menu filter-menu">
                      <FilterSearch />
                    </div>
                  </li>
                  <li>
                      <button className="tab-button btn-small-box btn btn-border d-flex align-items-center gap-2"> 
                        <span className='text-box'>Stripper</span>
                        <span className='icon-box'>
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7.66667" stroke="#787486" stroke-linejoin="round"/><path d="M7 1L1 7.66667" stroke="#787486" stroke-linejoin="round"/></svg>
                        </span>
                      </button>
                  </li>
                  <li>
                      <button className="tab-button btn-small-box btn btn-border d-flex align-items-center gap-2"> 
                        <span className='text-box'>Age 18-29</span>
                        <span className='icon-box'>
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7.66667" stroke="#787486" stroke-linejoin="round"/><path d="M7 1L1 7.66667" stroke="#787486" stroke-linejoin="round"/></svg>
                        </span>
                      </button>
                  </li>
                  <li>
                      <button className="tab-button btn-small-box btn btn-border d-flex align-items-center gap-2"> 
                        <span className='text-box'>Caucasian</span>
                        <span className='icon-box'>
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7.66667" stroke="#787486" stroke-linejoin="round"/><path d="M7 1L1 7.66667" stroke="#787486" stroke-linejoin="round"/></svg>
                        </span>
                      </button>
                  </li>
                </ul>

              </div>

            </div>
          </div>

        <div className="tabs-content BookingTabsSec">
          {activeTab === 0 && (
              <div className="tab-panel">
                  <SearchService />
              </div>
          )}
          {activeTab === 1 && (
              <div className="tab-panel">
                <SearchWorker />
              </div>
          )}
        </div>
    </>          
  )
}

export default SearchTopBox
